"use client";

import TicketIcon from "@heroicons/react/24/solid/TicketIcon";
import { VENUE_TABS } from "@/@core/constants/venue-tabs";
import CampaignList from "@/components/views/campaings/CampaignList";
import { useEffect, useRef, useState } from "react";

interface props {
  datas: {
    descriptions: [
      {
        title: string;
        description: string;
      },
    ][];
    services: {
      service: {
        descriptions: [
          {
            title: string;
          },
        ];
      };
    }[];
  }[];
  venue: Venue.Detail;
}

export default function Campaign(props: props) {
  const campaingRef: any = useRef(null);

  return (
    <>
      {props.datas.length > 0 && (
        <div
          id={VENUE_TABS.CAMPAIGNS}
          className="flex relative flex-col mt-6 mb-6 lg:max-w-[895px] border rounded-[32px] px-4 pt-4 pb-2 gap-4"
        >
          <div className="flex bg-stone-50 rounded-[16px] py-1.5 px-2 gap-2">
            <TicketIcon className="size-5 text-primary" />
            <h2 className="text-primary font-bold text-sm">Kampanyalar</h2>
            <div className="py-[2px] cursor-default px-[6px] text-xs bg-primary text-white font-[500] rounded-full">
              {props.datas.length}
            </div>
          </div>

          <div
            ref={campaingRef}
            className="overflow-x-auto custom-sidebar scroll-smooth grid grid-cols-1 md:grid-cols-2 gap-4 pb-2 custom-scrollbar"
          >
            <CampaignList
              titleHeadingLevel="h3"
              campaigns={props.datas as any}
              venue={props.venue}
            />
          </div>
        </div>
      )}
    </>
  );
}
